<template>
    <span :title="JSON.stringify(ticketUser)">#{{ticketUser.id}} {{ticketUser.name}}</span>
</template>

<script>
export default {
    name : "TicketUserById",

    props : ['value'],

    data() {
        return {
            ticketUser : {}
        };
    },

    mounted() {
        var _this = this;
        sdk.TicketUserApi().findById({
            id : _this.value
        }).then(res => {
            _this.ticketUser = res || { id : _this.value };
        });
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/setting/TicketUserById.vue